var _circle, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBoardRelations(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23.7947,
    cy: 23.7751,
    r: 21.8327,
    fill: "white",
    stroke: "#FF7900",
    strokeWidth: 2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8492_10680)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.3369 24.2609C22.3369 24.7762 22.5416 25.2705 22.9061 25.6349C23.2705 25.9993 23.7648 26.2041 24.2801 26.2041C24.7955 26.2041 25.2898 25.9993 25.6542 25.6349C26.0186 25.2705 26.2233 24.7762 26.2233 24.2609C26.2233 23.7455 26.0186 23.2512 25.6542 22.8868C25.2898 22.5224 24.7955 22.3176 24.2801 22.3176C23.7648 22.3176 23.2705 22.5224 22.9061 22.8868C22.5416 23.2512 22.3369 23.7455 22.3369 24.2609Z",
    stroke: "#FF7900",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3936 32.0337V31.0621C20.3936 30.5467 20.5983 30.0525 20.9627 29.6881C21.3271 29.3236 21.8214 29.1189 22.3368 29.1189H26.2232C26.7386 29.1189 27.2328 29.3236 27.5972 29.6881C27.9617 30.0525 28.1664 30.5467 28.1664 31.0621V32.0337",
    stroke: "#FF7900",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.1953 16.488C27.1953 17.0034 27.4 17.4976 27.7645 17.8621C28.1289 18.2265 28.6232 18.4312 29.1385 18.4312C29.6539 18.4312 30.1482 18.2265 30.5126 17.8621C30.877 17.4976 31.0817 17.0034 31.0817 16.488C31.0817 15.9726 30.877 15.4784 30.5126 15.114C30.1482 14.7495 29.6539 14.5448 29.1385 14.5448C28.6232 14.5448 28.1289 14.7495 27.7645 15.114C27.4 15.4784 27.1953 15.9726 27.1953 16.488Z",
    stroke: "#FF7900",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.1387 21.346H31.0819C31.5973 21.346 32.0915 21.5508 32.4559 21.9152C32.8204 22.2796 33.0251 22.7739 33.0251 23.2893V24.2609",
    stroke: "#FF7900",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4795 16.488C17.4795 17.0034 17.6842 17.4976 18.0486 17.8621C18.4131 18.2265 18.9073 18.4312 19.4227 18.4312C19.9381 18.4312 20.4323 18.2265 20.7968 17.8621C21.1612 17.4976 21.3659 17.0034 21.3659 16.488C21.3659 15.9726 21.1612 15.4784 20.7968 15.114C20.4323 14.7495 19.9381 14.5448 19.4227 14.5448C18.9073 14.5448 18.4131 14.7495 18.0486 15.114C17.6842 15.4784 17.4795 15.9726 17.4795 16.488Z",
    stroke: "#FF7900",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5361 24.2609V23.2893C15.5361 22.7739 15.7409 22.2796 16.1053 21.9152C16.4697 21.5508 16.964 21.346 17.4793 21.346H19.4226",
    stroke: "#FF7900",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8492_10680"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.3185,
    height: 23.3185,
    fill: "white",
    transform: "translate(12.6211 11.63)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoardRelations);
export default __webpack_public_path__ + "static/media/board-relations.48699b96e40cf4bcec94be50f2c44900.svg";
export { ForwardRef as ReactComponent };